// extracted by mini-css-extract-plugin
export default {"container":"SectionLivePrograms_container__17NG2","skeleton":"SectionLivePrograms_skeleton__GYJwa","grid":"SectionLivePrograms_grid__z8fmx"};